import {Box, Button, DialogActions, DialogContent, DialogContentText, TextField, Typography} from "@mui/material"
import {
	closeAttachmentModal,
	editNoteAttachment,
	postNoteAttachment, selectActionType,
	selectIsLinkValid,
	selectIsNoteAttachmentPreviewValid, selectIsSubmitting,
	selectNoteAttachmentPreview,
	updateNoteAttachmentPreview
} from "../../../../../../reducers/noteAttachmentsSlice"
import Attachment from "../../NoteAttachment/Attachment"
import {useDispatch, useSelector} from "react-redux"
import {useMemo} from "react"

export function LinkAttachmentModalBody({note}) {
	const dispatch = useDispatch()
	const { workspaceId } = note
	const attachmentPreview = useSelector((state) => selectNoteAttachmentPreview(state, workspaceId))
	const isLinkValid = useSelector((state) => selectIsLinkValid(state, workspaceId))
	const isAttachmentValidSelector = useMemo(() => selectIsNoteAttachmentPreviewValid(workspaceId), [workspaceId])
	const isAttachmentValid = useSelector(isAttachmentValidSelector)
	const actionType = useSelector((state) => selectActionType(state, workspaceId))
	const isSubmitting = useSelector((state) => selectIsSubmitting(state, workspaceId))

	return (
		<DialogContent>
			<DialogContentText variant="body1" sx={{color: "black"}} paragraph gutterBottom>
				{
					actionType === "create-link" && (
						`Attach a website URL on note: ${note?.content}`
					)
				}
				{
					actionType === "edit-link" && (
						`Edit attachment on note: ${note?.content}`
					)
				}
			</DialogContentText>
			<form onSubmit={(e) => {
				e.preventDefault()
				if (actionType === "create-link") {
					dispatch(postNoteAttachment({attachment: attachmentPreview, note }))
				}
				if (actionType === "edit-link") {
					dispatch(editNoteAttachment({attachment: attachmentPreview, note }))
				}
			}}>
				<TextField
					variant="outlined"
					label={"Add Your Link Here"}
					className="keyTextField"
					value={attachmentPreview?.url}
					onChange={(e) => dispatch(updateNoteAttachmentPreview({preview: {...attachmentPreview, url: e.target.value}, workspaceId}))}
					fullWidth
					error={!isLinkValid}
					required
				/>
				<TextField
					variant="outlined"
					label={"Title"}
					className="keyTextField"
					value={attachmentPreview?.title}
					onChange={(e) => dispatch(updateNoteAttachmentPreview({preview:{...attachmentPreview, title: e.target.value}, workspaceId}))}
					sx={{
						mt: 3, // shorthand for marginTop: theme.spacing(2)
						mb: 3, // shorthand for marginBottom: theme.spacing(2)
					}}
					fullWidth
					required
				/>
				<TextField
					variant="outlined"
					label={"Description"}
					className="keyTextField"
					value={attachmentPreview?.description}
					onChange={(e) => dispatch(updateNoteAttachmentPreview({preview: {...attachmentPreview, description: e.target.value}, workspaceId}))}
					fullWidth
					required
				/>

				<Box sx={{
					mt: 1,
					mb: 1
				}}>
					<Typography variant="subtitle1" component="div">
						Preview
					</Typography>
					<Attachment attachment={attachmentPreview} preview={true} />
				</Box>
				<DialogActions
					sx={{
						padding: 0,
						mt: 2
					}}
				>
					<Button
						variant="contained"
						color={"primary"}
						type="submit"
						disabled={isSubmitting || !isAttachmentValid}
					>
						{ actionType === "create-link" && "Attach Link" }
						{ actionType === "edit-link" && "Update Link" }
					</Button>
					<Button
						variant={"outlined"}
						color="primary"
						onClick={() => dispatch(closeAttachmentModal(workspaceId))}
					>
						Cancel
					</Button>
				</DialogActions>
			</form>
		</DialogContent>
	)
}